import React, {useState, useContext, useEffect, useRef, useMemo} from 'react';
import styled from 'styled-components';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import BodyTree from './BodyTree';
import {FormBodyTypeIdContext} from '../../FormBodyContainer';
import {DocumentEngagementIdContext} from '../../../../../Main/Forms/CanvasFormContainer';
import CompareSnapshotLabel from '../../../../CanvasForm/CompareSnapshotLabel';
import EditADCContainer from '../../../../../Main/ADC/EditADCContainer';
import Utility from '../../../../../../util/utilityfunctions';
import {strategyTypes, formBodyType, riskTypes, entities} from '../../../../../../util/uiconstants';
import {labels} from '../../../../../../util/utils';
import {CreateUpdateEntityContainer} from '../../../../../Common/CanvasForm/Bodies/BodyTypes/BodySpecial/CreateUpdateEntities/index';
import {useDocumentId, useEngagementId, useUserPreferences} from '../../../../../../util/customHooks';

export default function ScotRelatedObject(props) {
	const {data, isTopLevel, bodyId, isSnapshotView} = props;
	const currentLevel = isTopLevel ? 1 : data.level;

	const strategyTypeId = data.strategyTypeId === undefined || data.strategyTypeId === null ? 0 : data.strategyTypeId,
		strategyTypeLabel = labels.strategyType[strategyTypeId].StrategyTypeName;

	const [scotData, setScotData] = useState(data),
		[showModal, setShowModal] = useState(false);

	const modalRef = useRef();

	//This is until all entities are migrated to CreateUpdateEntityContainer
	const createUpdateEntities = useMemo(() => [entities.SCOT], [entities]);

	const engagementId = useEngagementId(),
		documentEngagementId = useContext(DocumentEngagementIdContext),
		documentId = useDocumentId(),
		userPreferences = useUserPreferences(),
		formBodyTypeId = useContext(FormBodyTypeIdContext);

	const loadEdit = () => {
		if (!isSnapshotView) {
			setShowModal(!showModal);
			if (modalRef.current.toggleModal) {
				modalRef.current.toggleModal();
			}
		}
	};

	const showHideModel = (showModal) => {
		setShowModal(showModal);
	};

	useEffect(() => {
		if (data && data.children && data.children.length > 0) {
			let filteredScots = data.children.filter((risk) => {
				if (risk.entityId === entities.Risk && risk.children === null) {
					return risk.riskTypeId !== riskTypes.INHERENTRISK;
				}
			});

			if (formBodyTypeId === formBodyType.RelatedRisks) {
				data.children = filteredScots;
			}
		}
		if (data) {
			setScotData(data);
		}
	}, [data]);

	let scotContent;
	let strategyLabel;
	const scotStrategyTypeId =
		scotData.strategyTypeId === undefined || scotData.strategyTypeId === null ? 0 : scotData.strategyTypeId;

	switch (formBodyTypeId) {
		// eslint-disable-next-line no-case-declarations
		case formBodyType.RelatedRisks:
			switch (scotStrategyTypeId) {
				case strategyTypes.CONTROLS:
					strategyLabel = labels.strategyType[strategyTypes.CONTROLS].strategyTypeName;
					break;
				case strategyTypes.SUBSTANTIVE:
					strategyLabel = labels.strategyType[strategyTypes.SUBSTANTIVE].strategyTypeName;
					break;
				case strategyTypes.RELY:
					strategyLabel = labels.strategyType[strategyTypes.RELY].strategyTypeName;
					break;
				case strategyTypes.NOTRELY:
					strategyLabel = labels.strategyType[strategyTypes.NOTRELY].strategyTypeName;
					break;
				case 0:
					strategyLabel = labels.notSelected;
					break;
			}
			scotContent = (
				<>
					<section
						className={`entity-content-main scotEntityContentMain ${Utility.getClasstoDisableADCLink(
							userPreferences,
							isSnapshotView
						)}`}
					>
						<EllipsesControl
							onClick={loadEdit}
							content={Utility.getHtmlTextElement(scotData.entityName, isSnapshotView)}
							tooltip={Utility.getHtmlTextElement(scotData.entityName, isSnapshotView)}
							noOfLines={1}
						/>
						{/* <section className="CountWrapper">{scotData?.children?.length}</section> */}
					</section>
					<section
						className={`entity-content-data scotEntityContentData ${Utility.getClasstoDisableADCLink(
							userPreferences,
							isSnapshotView
						)}`}
					>
						{scotData && <EllipsesControl content={strategyLabel} tooltip={strategyLabel} noOfLines={1} />}
						{isSnapshotView && <CompareSnapshotLabel snapshotObject={scotData} />}
					</section>
				</>
			);
			break;
		default:
			scotContent = (
				<>
					{!isSnapshotView ? (
						<>
							<section
								className={`entity-content-main scotEntityContentMain ${
									!bodyId ? '' : 'scotEntityContentWrapper'
								} ${Utility.getClasstoDisableADCLink(userPreferences, isSnapshotView)}`}
							>
								<section className="scotRelatedObjectTextWrapper">
									<span onClick={loadEdit} className="RelatedObjectTextWrapper">
										<EllipsesControl content={scotData.entityName} tooltip={scotData.entityName} noOfLines={3} />
									</span>
								</section>
							</section>
							<section className="entity-content-data SecondCol">
								{scotData && scotData.strategyTypeId > 0 && (
									<EllipsesControl content={strategyTypeLabel} tooltip={strategyTypeLabel} noOfLines={1} />
								)}
							</section>
						</>
					) : (
						<>
							{' '}
							<section
								className={`entity-content-main ${Utility.getClasstoDisableADCLink(userPreferences, isSnapshotView)}`}
							>
								<EllipsesControl
									content={Utility.getHtmlTextElement(scotData.entityName, isSnapshotView)}
									tooltip={Utility.getHtmlTextElement(scotData.entityName, isSnapshotView)}
									noOfLines={1}
									width={nameWidth}
								/>
							</section>
							<CompareSnapshotLabel snapshotObject={scotData} />{' '}
						</>
					)}
				</>
			);
			break;
	}

	let noChildrenLabel;

	switch (formBodyTypeId) {
		case formBodyType.RelatedRisks:
			noChildrenLabel = labels.noRelatedRisks;
			break;
	}

	return (
		<StyledScotRelatedObject className={`ScotRelatedObject entity-content entity-content-level-${currentLevel}`}>
			{createUpdateEntities.includes(data.entityId) ? (
				<CreateUpdateEntityContainer
					entityId={data.entityId}
					entityUId={data.entityUId}
					entityName={data.entityName}
					documentId={documentId}
					documentEngagementId={documentEngagementId}
					engagementId={engagementId}
					ref={modalRef}
					bodyId={bodyId}
				/>
			) : (
				!isSnapshotView &&
				showModal && (
					<EditADCContainer
						showHideModel={showHideModel}
						documentId={documentId}
						documentEngagementId={documentEngagementId}
						engagementId={engagementId}
						bodyId={bodyId}
						item={scotData}
						objectEntityId={scotData.entityUId}
					/>
				)
			)}
			<BodyTree
				key={bodyId}
				data={scotData}
				bodyId={bodyId}
				defaultOpen
				isSnapshotView={isSnapshotView}
				open
				noChildrenLabel={noChildrenLabel}
			>
				{scotContent}
			</BodyTree>
		</StyledScotRelatedObject>
	);
}

const StyledScotRelatedObject = styled.section`
	&.entity-content {
		&.entity-content-level-1 {
			.tree {
				overflow-x: hidden;
				.tree-content {
					max-height: unset;
				}
			}
			.tree-trigger-children {
				line-height: normal;
				width: calc(100% - var(--px-30));
			}
			.scotEntityContentMain {
				width: calc(100% - var(--px-150)) !important;
				padding-right: var(--px-10);
				line-height: normal;
				.ellipses {
					width: auto;
					max-width: calc(100% - var(--px-40));
					div {
						cursor: pointer;
					}
				}
				.CountWrapper {
					margin-left: var(--px-10);
				}
				.RelatedObjectTextWrapper {
					width: 100% !important;
				}
				&.disableLinksExternalUsers {
					pointer-events: none;
				}
				& + .entity-content-data {
					max-width: var(--px-200);
					min-width: var(--px-150);
					margin-left: 0;
					padding-left: var(--px-3);
				}
				&:hover {
					.CountWrapper {
						text-decoration: none;
					}
				}
			}
		}
		&.entity-content-level-3 {
			.tree-trigger-children {
				width: calc(100% - var(--px-20));
			}
			.entity-content-main {
				width: calc(100% - var(--px-200));
				line-height: normal;
				&.disableLinksExternalUsers {
					pointer-events: none;
				}
				.scotRelatedObjectTextWrapper {
					display: inline;
					max-width: 100%;
					width: 100%;
					border: var(--px-1) solid transparent;
					.RelatedObjectTextWrapper {
						border: var(--px-1) solid transparent;
						.ellipses-multilines {
							display: inline-block;
							max-width: 100%;
						}
					}
				}
			}
		}
		&.entity-content-level-4 {
			.WcgwRelatedObjectWrapper {
				display: inline;
				max-width: 100%;
			}
		}
	}
`;
